// src/pages/payment/PaymentSuccess.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { doc, updateDoc, query, collection, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase/config';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  useEffect(() => {
    const updateStatuses = async () => {
      if (!user) return;

      try {
        // Son siparişi bul
        const ordersRef = collection(db, `/users/${user.email}/orders`);
        const q = query(ordersRef, orderBy('createdAt', 'desc'), limit(1));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          const lastOrder = querySnapshot.docs[0];
          const orderData = lastOrder.data();
          
          // Üyelik bitiş tarihini hesapla
          const now = new Date();
          const endDate = new Date(now);
          
          if (orderData.planType === 'yearly') {
            endDate.setFullYear(now.getFullYear() + 1);
          } else {
            endDate.setMonth(now.getMonth() + 1);
          }

          // Kullanıcı durumunu güncelle
          const userRef = doc(db, 'users', user.email);
          await updateDoc(userRef, {
            status: 'active',
            membershipStatus: 'active',
            membershipStartDate: now.toISOString(),
            membershipEndDate: endDate.toISOString(),
            membershipType: orderData.planType,
            updatedAt: now.toISOString()
          });

          // Sipariş durumunu güncelle
          await updateDoc(doc(db, `/users/${user.email}/orders`, lastOrder.id), {
            status: 'active',
            paymentStatus: 'completed',
            membershipEndDate: endDate.toISOString(),
            completedAt: now.toISOString()
          });
        }

      } catch (error) {
        console.error('Status güncelleme hatası:', error);
      }
    };

    updateStatuses();

    const timer = setTimeout(() => {
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, user]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
      <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
      <h1 className="text-2xl font-bold text-center mb-4">
        Ödeme Başarılı!
      </h1>
      <p className="text-center text-gray-600 dark:text-gray-300 mb-6">
        Ödemeniz başarıyla gerçekleştirildi. Ana sayfaya yönlendiriliyorsunuz...
      </p>
      <button
        onClick={() => navigate('/dashboard')}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Ana Sayfaya Dön
      </button>
    </div>
  );
};

export default PaymentSuccess;
